/** Preliminary owner checks researched from official Sundance and Viking manuals; service-team review recorded separately. */
export const serviceSymptoms = [
  {
    label: 'It is not heating',
    help: [
      'Check the set temperature and heating mode. Economy or rest settings can limit when a spa heats.',
      'Keep the cover fitted while the water warms. Check the water level against your owner’s manual and photograph any panel message.',
      'If the temperature keeps falling or heating does not resume, call us with the water temperature, set temperature and whether the spa was recently refilled. Loss of heat or circulation in freezing weather needs prompt attention.',
    ],
  },
  {
    label: 'It is losing water',
    help: [
      'Photograph the waterline and note how quickly it drops when the spa is not being used. Look around the outside for wet spots.',
      'If you recently drained the spa, check that an externally accessible drain is closed as your manual directs. Leave cabinet panels in place.',
      'A continuing drop needs a service call. Tell us where you see water and whether the loss changes when the jets run. Rapid water loss or a level too low for circulation needs prompt attention; do not keep running the jets with insufficient water.',
    ],
  },
  {
    label: 'The jets are acting strange',
    help: [
      'Check that the water is at the level specified in your manual. Use the normal jet controls to check the pump setting and adjustable jet or air-control positions. Do not force a control or close every jet.',
      'A dirty filter can restrict flow. Follow your model’s power-off and filter-care instructions before cleaning it.',
      'If a pump runs but little or no water moves, stop trying to run the jets and call us, especially after a refill. Tell us whether one seat or the whole spa is affected.',
    ],
  },
  {
    label: 'It is making an unusual noise',
    help: [
      'Note whether the sound occurs during filtration, with the massage jets or after a refill. Check the water level and look for an object outside the cabinet that may be vibrating.',
      'A short recording and a photo of the display can help us. Leave cabinet panels in place.',
      'A new grinding or screeching sound, or a pump humming without moving water, needs a service call. Stop testing the massage jets until you have advice. For a burning smell or smoke, keep clear and get urgent professional help.',
    ],
  },
  {
    label: 'The control panel is flashing',
    help: [
      'Take a clear photo or write down the complete message, including letters and numbers, and have your spa’s model and year ready.',
      'Flashing may indicate a temperature adjustment, maintenance reminder or fault; the meaning depends on the controls. Check the matching owner’s manual or contact us before trying a reset. Do not repeatedly cycle the breaker to clear a fault.',
      'If the display warns of overheating, or the water seems unusually hot, stay out of the spa and call for service.',
    ],
  },
]
